// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"538":"recorder","983":"profiler"}[chunkId] || chunkId) + "." + {"108":"f5e78ecdc9dae735","538":"4bd4aa16f44ab829","549":"9ecff0cf65b4afae","973":"aada306c31a7725c","983":"b8b950f3f7c6ccfc"}[chunkId] + ".js";
};